import {
  Grid,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import * as React from "react";
import { FullScreen, ImagePreview, FileCard } from "@files-ui/react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const OCRDisplayDrawer = ({ ocrImages, setOcrImages }) => {
  //   const input = useSelector((state) => state.ResultReducer.input);
  //   const ocrImg = useSelector((state) => state.ResultReducer.ocrIcon);
  const [extraImg, setExtraImg] = React.useState([]);
  const [files, setfiles] = React.useState([]);

  const [imgSrc, setImgSrc] = React.useState(undefined); // for image preview
  const handleSee = (image) => {
    setImgSrc(image);
  };
  //   const handleDelete = (id) => {
  //     let tempExtraImg = clone(extraImg);
  //     //let tempOcrImg = clone(ocrImg);
  //     console.log("tempExtraImg", tempExtraImg);
  //     tempExtraImg = tempExtraImg.filter((item) => item.id !== id);
  //     tempOcrImg = tempOcrImg.filter((item) => item !== id);
  //     setExtraImg(tempExtraImg);
  //     //dispatch(set_ocrImage(tempOcrImg));
  //     console.log("delete button clicked on file: " + id);
  //   };

  React.useEffect(() => {
    const convertOCRImages = () => {
      const ocrBlock = ocrImages.map((img, i) => {
        let format = img.split(".").pop().toLowerCase();
        let imageSample = {
          id: img,
          type: "image/" + format,
          name: i + "." + format,
          imageUrl: `${process.env.REACT_APP_API_HOST}/v2/image/${img}`,
        };
        return imageSample;
      });
      setExtraImg(ocrBlock);
    };
    if (ocrImages) {
      convertOCRImages();
    }
  }, [ocrImages]);
  //   React.useEffect(() => {
  //     console.log("ocrImages", ocrImages);
  //   }, [ocrImages]);
  //   React.useEffect(() => {
  //     console.log("ocrWriting", ocrWriting);
  //   }, [ocrWriting]);

  return (
    <Grid container spacing={0}>
      <Accordion
        //defaultExpanded={ocrImg?.length === 0 ? false : true}
        disabled={ocrImages?.length === 0}
        sx={{
          mb: 1,
          width: "100%",
          position: "relative",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ flexGrow: 1 }}>
            使用OCR所上載的圖片 ({ocrImages.length} 張圖片/最多 6 張圖片)
          </Typography>
          <Button
            variant="contained"
            size="small"
            style={{ marginLeft: "auto", marginRight: 3  }}
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              setOcrImages([]);
            }}
          >
            清除圖片
          </Button>
        </AccordionSummary>
        <AccordionDetails>
          {ocrImages?.length > 0 ? (
            <Stack direction="column" spacing={1} sx={{ mt: 2 }}>
              <Grid container direction={"row"} spacing={1}>
                {extraImg.map((img, i) => {
                  return (
                    <Grid item key={i}>
                      <FileCard
                        id={i}
                        {...img}
                        onSee={handleSee}
                        //onDelete={handleDelete}
                      />
                      <FullScreen
                        open={imgSrc !== undefined}
                        onClose={() => setImgSrc(undefined)}
                      >
                        <ImagePreview src={imgSrc} />
                      </FullScreen>
                    </Grid>
                  );
                })}
              </Grid>
            </Stack>
          ) : null}
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default OCRDisplayDrawer;
